<main id="main">

    <kokos-header [page]="PagesEnum.SendMail" [title]="'sendmail.confirmation.title' | i18next"></kokos-header>


    <div class="container-fluid">

        <div class="ba-content-main">

            <pf-hinweisbox [boxType]="HinweisboxTypeEnum.SUCCESS" boxId="success" role="alert">
                @if (nachrichtSuccessType === NachrichtSuccessType.SENT) {
                    {{ 'sendmail.confirmation.msg-sent' | i18next }}
                } @else {
                    {{ 'sendmail.confirmation.msg-saved-draft' | i18next }}
                }
            </pf-hinweisbox>

            <pf-footer [forwardButton]="forwardButtonConfig" [backButton]="backButtonConfig"
                       (forwardButtonClicked)="handleForwardClicked()"
                       (backButtonClicked)="handleBackClicked()"></pf-footer>
        </div>

    </div>

</main>